var exports = {
  "kL": "VoiceControlBar.module__container___SXRwT2",
  "UD": "VoiceControlBar.module__buttonContainer___SXRwT2",
  "x6": "VoiceControlBar.module__button___SXRwT2",
  "QV": "VoiceControlBar.module__buttonMuted___SXRwT2",
  "rp": "VoiceControlBar.module__buttonUnmuted___SXRwT2",
  "Jt": "VoiceControlBar.module__buttonDeafened___SXRwT2",
  "Zj": "VoiceControlBar.module__buttonCameraOn___SXRwT2",
  "PQ": "VoiceControlBar.module__buttonCameraOff___SXRwT2",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___SXRwT2",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___SXRwT2",
  "_p": "VoiceControlBar.module__buttonMoreOptions___SXRwT2",
  "Zt": "VoiceControlBar.module__buttonDisconnect___SXRwT2",
  "Q1": "VoiceControlBar.module__buttonSeparator___SXRwT2",
  "Se": "VoiceControlBar.module__settingsButton___SXRwT2",
  "on": "VoiceControlBar.module__stopWatchingButton___SXRwT2",
  "Kk": "VoiceControlBar.module__icon___SXRwT2",
  "Bx": "VoiceControlBar.module__iconSmall___SXRwT2",
};

module.exports = exports;
